import React, { useEffect, useRef, useState } from "react"
import htmlParser from "html-react-parser"
import { addAnalyticsCallSupportNumber } from "@/components/Shared/CustomerSupport/analytics"

import Style from "@/components/Shared/CustomerSupport/index.module.scss"

const CustomerSupport = props => {
  const { supportInfo, name } = props || {}
  const [isClient, setIsClient] = useState(false)
  const needHelpRef = useRef(null)

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (!isClient) return
    const contactUsContainer = needHelpRef.current ?? ""

    if (contactUsContainer) {
      const anchorTags = contactUsContainer?.querySelectorAll("a") ?? []
      anchorTags.forEach(e => {
        e.addEventListener("click", event =>
          addAnalyticsCallSupportNumber(event, name)
        )
      })
    }

    return () => {
      if (contactUsContainer) {
        const anchorTags = contactUsContainer?.querySelectorAll("a") ?? []
        anchorTags.forEach(e =>
          e.removeEventListener("click", addAnalyticsCallSupportNumber)
        )
      }
    }
  }, [isClient])

  if (!supportInfo) return null
  return (
    <p className={Style.CustomerSupport} ref={needHelpRef}>
      {htmlParser(supportInfo)}
    </p>
  )
}

export default CustomerSupport
